export enum modalTypeEnum {
    none = 0,
    walletLogin = 1,
    register = 2,
    deviceLogin = 3,
    npos = 4,
    unauthorized = 5,
    badPassword = 6,
    withdrawal = 7,
    receipt = 8,
    invalidToken = 9,
    serverError = 10,
    generalError = 11,
    invalideteNpos = 12,
    maintenance = 13,
    infoSlippage = 20
}

export enum modalStatusEnum {
    none = 0,
    info = 1,
    processing = 2,
    done = 3,
    success = 4,
    error = 5
}

export type ModalSliceInitiator = {
    modalStatus: modalStatusEnum,
    modalMessage: string,
    modalReset: boolean
}